import { Static, Type } from '@sinclair/typebox';

export const SetPresenceResponseSchema = Type.Object({
  object: Type.Literal('PresenceSet'),
});

export type SetPresenceResponse = Static<typeof SetPresenceResponseSchema>;
